<template>
  <!-- 第五部分 -->
  <div class="payment-fifth-border">
    <div class="payment-fifth-content-parent">
      <!-- 第五部分的图片 -->
      <div class="payment-fifth-content-img">
        <img src="../../assets/payment-fifth-1x.png"/>
      </div>
      <!-- 第五部分右边的内容 -->
      <div class="payment-fifth-content-text">
        <div class="payment-fifth-content-text-title">More inventory means more sales</div>
        <div class="payment-fifth-content-text-main">“Net 60 has played a big part in helping my business grow. It helps me use my cash everywhere I need to, and bring in more brands quicker than before. Love our reps, but if I can get net 60 I mean, HELLO.”</div>
        <div class="payment-fifth-content-text-bottom-border">
          <div class="payment-fifth-content-text-bottom1">Jasmine Helen</div>
          <div class="payment-fifth-content-text-bottom2">Cleanse Apothecary</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
/* 第五部分 */
.payment-fifth-border{width: 100%;min-height: 600px;background: #F4F4F4;opacity: 1;height: auto;}
.payment-fifth-content-parent{width: auto;max-width: 1400px;margin: 0 auto;display: flex;height: 100%;align-items: center;}
.payment-fifth-content-img{width: 50%;display: flex;justify-content: center;align-items: center;margin-top: 100px;}
.payment-fifth-content-text{width:50%;display: flex;flex-direction: column;justify-content: center ;margin-top: 100px;}
.payment-fifth-content-text-title{font-size: 36px;font-family: STIXGeneral;font-weight: 400;line-height: 97px;color: #000000;opacity: 1;}
.payment-fifth-content-text-main{font-size: 20px;font-family: Graphik;font-weight: 500;line-height: 32px;color: #262B2F;opacity: 1;margin:50px 0}
.payment-fifth-content-text-bottom-border{margin-top: 30px;}
.payment-fifth-content-text-bottom1{font-size: 36px;font-family: Graphik;font-weight: 500;line-height: 32px;color: #262B2F;opacity: 1;}
.payment-fifth-content-text-bottom2{font-size: 20px;font-family: Graphik;font-weight: 500;line-height: 32px;color: #262B2F;opacity: 1;}
@media screen and (max-width: 600px) {
  .payment-fifth-content-parent{flex-direction: column;}
  .payment-fifth-content-img{width: 60%;margin:20px auto}
  .payment-fifth-content-text{width: 100%;}
  .payment-fifth-content-text-title{font-size: 28px;margin:0 auto;line-height: 57px}
  .payment-fifth-content-text-main{font-size: 16px;margin:20px auto;width: 90%;}
  .payment-fifth-content-text-bottom1{font-size: 28px;width: 90%;margin:0 auto}
  .payment-fifth-content-text-bottom2{font-size: 16px;width: 90%;margin:0 auto}
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/payment-fifth.vue